import { render, staticRenderFns } from "./RouteLink.vue?vue&type=template&id=78603094&scoped=true"
import script from "./RouteLink.vue?vue&type=script&lang=js"
export * from "./RouteLink.vue?vue&type=script&lang=js"
import style0 from "./RouteLink.vue?vue&type=style&index=0&id=78603094&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78603094",
  null
  
)

export default component.exports